// extracted by mini-css-extract-plugin
export var formInfo = "fR_PB";
export var formInfo__image = "fR_Pv";
export var formInfo__link = "fR_Pz";
export var formInfo__list = "fR_Px";
export var formInfo__sectionHr = "fR_Py";
export var formInfo__services = "fR_Pt";
export var formInfo__title = "fR_Pw";